(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    #messages = [];
    #track = null;
    #intervalId = null;
    #index = 0;
    #isHoverPaused = false;
    #isFocusPaused = false;
    #reducedMotion = false;
    #boundOnMouseEnter = this.#onMouseEnter.bind(this);
    #boundOnMouseLeave = this.#onMouseLeave.bind(this);
    #boundOnFocusIn = this.#onFocusIn.bind(this);
    #boundOnFocusOut = this.#onFocusOut.bind(this);
    #boundOnVisibilityChange = this.#onVisibilityChange.bind(this);

    connectedCallback() {
      this.#track = this.querySelector('[data-announcement-track]');
      this.#messages = Array.from(this.querySelectorAll('[data-announcement-message]')).filter(
        (message) => message.dataset.empty !== 'true'
      );

      if (!this.#track) return;

      this.#messages.forEach((message, index) => {
        const isActive = index === 0;
        message.classList.toggle('is-active', isActive);
        message.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        message.inert = !isActive;
      });

      // Liquid's block_count can include hidden theme blocks. Only messages
      // that actually rendered can cycle — two or more starts the rollover.
      if (this.#messages.length < 2) return;

      this.removeAttribute('data-static');
      this.closest('.announcement-bar')?.classList.add('announcement-bar--rotating');

      this.#reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.setAttribute('data-ready', '');
      this.addEventListener('focusin', this.#boundOnFocusIn);
      this.addEventListener('focusout', this.#boundOnFocusOut);
      document.addEventListener('visibilitychange', this.#boundOnVisibilityChange);

      if (this.hasAttribute('data-pause-on-hover')) {
        this.addEventListener('mouseenter', this.#boundOnMouseEnter);
        this.addEventListener('mouseleave', this.#boundOnMouseLeave);
      }

      this.#start();
    }

    disconnectedCallback() {
      this.#stop();
      this.removeEventListener('focusin', this.#boundOnFocusIn);
      this.removeEventListener('focusout', this.#boundOnFocusOut);
      this.removeEventListener('mouseenter', this.#boundOnMouseEnter);
      this.removeEventListener('mouseleave', this.#boundOnMouseLeave);
      document.removeEventListener('visibilitychange', this.#boundOnVisibilityChange);
    }

    #getIntervalMs() {
      const seconds = Number(this.dataset.interval);

      if (!Number.isFinite(seconds) || seconds <= 0) return 5000;

      return seconds * 1000;
    }

    #start() {
      if (this.#isHoverPaused || this.#isFocusPaused || document.hidden) return;

      this.#stop();
      this.#intervalId = window.setInterval(() => {
        this.#advance();
      }, this.#getIntervalMs());
    }

    #stop() {
      if (this.#intervalId !== null) {
        window.clearInterval(this.#intervalId);
        this.#intervalId = null;
      }
    }

    #advance() {
      const current = this.#messages[this.#index];
      const nextIndex = (this.#index + 1) % this.#messages.length;
      const next = this.#messages[nextIndex];

      current.classList.remove('is-active');
      current.classList.add('is-exiting');
      current.setAttribute('aria-hidden', 'true');
      current.inert = true;

      next.classList.remove('is-exiting');
      next.classList.add('is-active');
      next.setAttribute('aria-hidden', 'false');
      next.inert = false;

      this.#index = nextIndex;

      const transitionMs = this.#reducedMotion ? 1 : 400;

      window.setTimeout(() => {
        current.classList.remove('is-exiting');
      }, transitionMs);
    }

    #onMouseEnter() {
      this.#isHoverPaused = true;
      this.#stop();
    }

    #onMouseLeave() {
      this.#isHoverPaused = false;
      this.#start();
    }

    #onFocusIn() {
      this.#isFocusPaused = true;
      this.#stop();
    }

    #onFocusOut(event) {
      if (this.contains(event.relatedTarget)) return;

      this.#isFocusPaused = false;
      this.#start();
    }

    #onVisibilityChange() {
      if (document.hidden) {
        this.#stop();
        return;
      }

      // Browsers differ on whether hiding a tab fires focusout, so re-derive from live focus.
      this.#isFocusPaused = this.contains(document.activeElement);
      this.#start();
    }
  }

  if (!customElements.get('announcement-bar')) {
    customElements.define('announcement-bar', AnnouncementBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-video-banner"] && !Shopify.designMode) return;
  try {
    
  class UWPImageVideoBanner extends HTMLElement {
    connectedCallback() {
      if (!this.hasAttribute('data-video-background')) return;

      this.#videos = Array.from(this.querySelectorAll('video'));
      this.#button = this.querySelector('[data-image-video-banner-playback]');
      this.#audioButton = this.querySelector('[data-image-video-banner-audio]');
      this.#playIcon = this.querySelector('.image-video-banner__playback-icon--play');
      this.#pauseIcon = this.querySelector('.image-video-banner__playback-icon--pause');
      this.#mutedIcon = this.querySelector('[data-image-video-banner-muted-icon]');
      this.#soundIcon = this.querySelector('[data-image-video-banner-sound-icon]');
      this.#audioState = this.querySelector('[data-image-video-banner-audio-state]');
      this.#playLabel = this.getAttribute('data-play-label') || 'Play video';
      this.#pauseLabel = this.getAttribute('data-pause-label') || 'Pause video';
      this.#muteLabel = this.getAttribute('data-mute-label') || 'Mute video';
      this.#unmuteLabel = this.getAttribute('data-unmute-label') || 'Unmute video';
      this.#mutedState = this.getAttribute('data-muted-state') || 'Video muted';
      this.#unmutedState = this.getAttribute('data-unmuted-state') || 'Video unmuted';
      this.#desktopMq = window.matchMedia('(min-width: 768px)');
      this.#reducedMotionMq = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.#isPlaying = !this.#reducedMotionMq.matches;

      if (this.#button) this.#button.addEventListener('click', this.#onToggle);
      if (this.#audioButton) this.#audioButton.addEventListener('click', this.#onAudioToggle);

      this.#desktopMq.addEventListener('change', this.#onBreakpointChange);
      this.#reducedMotionMq.addEventListener('change', this.#onReducedMotionChange);
      this.addEventListener('theme:video:audio', this.#onAudioDetected);
      this.#syncActiveMedia();
    }

    disconnectedCallback() {
      if (this.#button) this.#button.removeEventListener('click', this.#onToggle);
      if (this.#audioButton) this.#audioButton.removeEventListener('click', this.#onAudioToggle);
      if (this.#desktopMq) this.#desktopMq.removeEventListener('change', this.#onBreakpointChange);
      if (this.#reducedMotionMq) {
        this.#reducedMotionMq.removeEventListener('change', this.#onReducedMotionChange);
      }
      this.removeEventListener('theme:video:audio', this.#onAudioDetected);

      for (const video of this.#videos) video.pause();
    }

    #videos = [];
    #button = null;
    #audioButton = null;
    #playIcon = null;
    #pauseIcon = null;
    #mutedIcon = null;
    #soundIcon = null;
    #audioState = null;
    #playLabel = 'Play video';
    #pauseLabel = 'Pause video';
    #muteLabel = 'Mute video';
    #unmuteLabel = 'Unmute video';
    #mutedState = 'Video muted';
    #unmutedState = 'Video unmuted';
    #isPlaying = true;
    #isMuted = true;
    #desktopMq = null;
    #reducedMotionMq = null;

    #onToggle = () => {
      this.#isPlaying ? this.#pause() : this.#play();
    };

    #onBreakpointChange = () => {
      this.#syncActiveMedia();
    };

    #onReducedMotionChange = () => {
      if (this.#reducedMotionMq?.matches) this.#isPlaying = false;
      this.#syncActiveMedia();
    };

    #onAudioDetected = () => {
      this.#syncAudioAvailability();
    };

    #onAudioToggle = () => {
      const activeVideos = this.#getActiveVideos();
      if (!activeVideos.length) return;

      this.#setAudioState(!this.#isMuted);
    };

    #setAudioState(shouldMute) {
      this.#isMuted = shouldMute;

      for (const video of this.#videos) {
        video.muted = shouldMute;
        video.defaultMuted = shouldMute;
        video.volume = shouldMute ? 0 : 1;
        video.toggleAttribute('muted', shouldMute);
      }

      this.#syncAudioButton();
    }

    #getActiveVideos() {
      const isDesktop = this.#desktopMq?.matches ?? false;

      return this.#videos.filter((video) => {
        const layer = video.closest('.image-video-banner__layer');

        if (!layer) return true;

        if (layer.classList.contains('image-video-banner__layer--desktop')) {
          return isDesktop;
        }

        if (layer.classList.contains('image-video-banner__layer--mobile')) {
          return !isDesktop;
        }

        return true;
      });
    }

    #syncActiveMedia() {
      const activeVideos = this.#getActiveVideos();
      const hasActiveVideo = activeVideos.length > 0;

      for (const video of this.#videos) {
        if (activeVideos.includes(video)) continue;

        video.pause();
        video.autoplay = false;
      }

      if (this.#button) this.#button.hidden = !hasActiveVideo;

      this.#syncAudioAvailability();

      const activeVideoIds = activeVideos.map((video) => video.id).filter(Boolean).join(' ');
      for (const control of [this.#button, this.#audioButton]) {
        if (!control) continue;
        if (activeVideoIds) control.setAttribute('aria-controls', activeVideoIds);
        else control.removeAttribute('aria-controls');
      }

      if (!hasActiveVideo) return;

      if (this.#isPlaying) {
        this.#play();
      } else {
        this.#pause();
      }

      this.#syncAudioButton();
    }

    #syncAudioAvailability() {
      if (!this.#audioButton) return;

      const activeVideos = this.#getActiveVideos();
      // Silent or undecided footage gets no mute control: announcing "video
      // muted" without a confirmed audio track is misleading.
      const hasAudio = activeVideos.some((video) => video.dataset.hasAudio === 'true');
      this.#audioButton.hidden = activeVideos.length === 0 || !hasAudio;
    }

    #play() {
      const activeVideos = this.#getActiveVideos();

      for (const video of this.#videos) {
        if (activeVideos.includes(video)) {
          video.play().catch((error) => {
            // Autoplay policies only allow muted playback outside a user
            // gesture, so an unmuted layer cannot start on its own when the
            // viewport crosses the breakpoint. Fall back to muted and say so.
            if (error?.name !== 'NotAllowedError' || video.muted) {
              if (error?.name !== 'AbortError') this.#handlePlayFailure(video);
              return;
            }

            this.#setAudioState(true);
            video.play().catch(() => this.#handlePlayFailure(video));
          });
        } else {
          video.pause();
        }
      }

      this.#isPlaying = true;
      this.#syncButtonState();
    }

    #handlePlayFailure(video) {
      if (!this.#getActiveVideos().includes(video) || !video.paused) return;

      this.#isPlaying = false;
      this.#syncButtonState();
    }

    #pause() {
      for (const video of this.#videos) {
        video.pause();
      }

      this.#isPlaying = false;
      this.#syncButtonState();
    }

    #syncButtonState() {
      if (!this.#button) return;

      this.#button.setAttribute(
        'aria-label',
        this.#isPlaying ? this.#pauseLabel : this.#playLabel
      );

      if (this.#playIcon) this.#playIcon.hidden = this.#isPlaying;
      if (this.#pauseIcon) this.#pauseIcon.hidden = !this.#isPlaying;
    }

    #syncAudioButton() {
      if (!this.#audioButton) return;

      this.#audioButton.setAttribute(
        'aria-label',
        this.#isMuted ? this.#unmuteLabel : this.#muteLabel
      );
      this.#audioButton.setAttribute('aria-pressed', String(!this.#isMuted));
      if (this.#mutedIcon) this.#mutedIcon.hidden = !this.#isMuted;
      if (this.#soundIcon) this.#soundIcon.hidden = this.#isMuted;
      if (this.#audioState) {
        this.#audioState.textContent = this.#isMuted ? this.#mutedState : this.#unmutedState;
      }
    }
  }

  if (!customElements.get('uwp-image-video-banner')) {
    customElements.define('uwp-image-video-banner', UWPImageVideoBanner);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["returns-form"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const HOST_SELECTOR = '[data-returns-form]';
    const STYLE_ATTR = 'data-returns-form-helper-style';
    const HIDDEN_TITLE_ATTR = 'data-returns-form-hidden-title';

    const FORM_CSS = `
      :host {
        display: block !important;
        width: 100% !important;
        max-width: 100% !important;
        --inline-container-max-width: 100%;
        --container-max-w: 100%;
        --forms-body-font: var(--font-body--family, inherit);
        --forms-heading-font: var(--font-body--family, inherit);
        --form-text-color: var(--text-primary, inherit);
        --heading-text-color: var(--text-secondary, inherit);
      }

      /* !important: Forms hard-caps these wrappers near 28rem */
      [data-sizing="form-wrapper"],
      [data-sizing="form-wrapper"] > *,
      [class*="formContainer"],
      [class*="formWrapper"] {
        box-sizing: border-box;
        width: 100% !important;
        max-width: 100% !important;
      }

      [data-testid="form"] {
        display: flex;
        box-sizing: border-box;
        flex-direction: column;
        gap: var(--spacing-md, 24px);
        align-items: stretch;
        width: 100%;
        max-width: 100%;
        text-align: left;
      }

      /* Legacy DPD lead-time copy lives in the form description; the redesign drops it */
      [data-testid="form-description"],
      [class*="formDescription"],
      [${HIDDEN_TITLE_ATTR}] {
        display: none;
      }

      /* The in-form section heading reads as muted body copy on the live portal */
      [data-testid="form"] h2,
      [data-testid="form"] h3,
      [class*="formHeading"],
      [class*="headingText"] {
        margin: 0;
        font-family: var(--font-body--family, inherit);
        font-size: var(--font-body-xl-size, 16px);
        font-weight: var(--font-body-xl-weight, 400);
        line-height: var(--font-body-xl-line-height, 1.3);
        color: var(--text-secondary, inherit);
        text-align: left;
      }

      /* Forms draws its own field outline as a box-shadow ring — grey at rest, 2px brand green
         on focus — and zeroes the border on inputs but not on the textarea. A border here was
         therefore double-drawn on the textarea alone, so leave the outline to the app. */
      [class*="formInputField"] input,
      [class*="formPhoneInputField"] input,
      [class*="formFieldContainer"] input,
      [class*="formFieldContainer"] textarea,
      textarea {
        box-sizing: border-box;
        width: 100%;
        color: var(--text-primary, inherit);
        background-color: var(--surface-primary, transparent);
      }

      [class*="selectContainer"],
      [class*="formSelect"],
      [class*="selectField"] {
        position: relative;
        box-sizing: border-box;
        width: 100%;
        min-height: 2.75rem;
        border: 0;
        background-color: transparent;
      }

      [class*="selectContainer"] [class*="selectContainer"],
      [class*="formSelect"] [class*="selectContainer"],
      [class*="selectField"] [class*="selectContainer"] {
        border: 0;
        min-height: 0;
      }

      /* Border the wrapper only — a toggle border is the stray line inside the closed control */
      [class*="selectToggle"],
      [class*="selectContainer"] select,
      [class*="formSelect"] select {
        box-sizing: border-box;
        display: flex;
        align-items: center;
        width: 100%;
        min-height: 2.75rem;
        padding-inline: 0.75rem;
        border: 0;
        box-shadow: none;
        background: transparent;
        color: var(--text-primary, inherit);
      }

      [data-testid="form"] [data-testid="btn-form-submit"] {
        display: inline-flex;
        box-sizing: border-box;
        align-items: center;
        align-self: start;
        justify-content: center;
        width: fit-content;
        min-width: 0;
        max-width: 100%;
        min-height: var(--size-8, 32px);
        margin: var(--spacing-xs, 16px) 0 0;
        /* The theme button's 1px transparent border is folded into the padding instead.
           Forms zeroes border-width on hover with a rule we can't outrank, which shrank
           the button by 2px the moment the pointer landed on it */
        padding: calc(var(--spacing-3xs, 8px) + 1px) calc(var(--spacing-xs, 16px) + 1px);
        border: 0;
        border-radius: var(--radius-full, 360px);
        background-color: var(--surface-brand-dark, #4d9d34);
        color: var(--text-invert, #fff);
        box-shadow: none;
        font-family: var(--font-subheading--family, inherit);
        font-size: var(--font-button-sm-size, 12px);
        font-weight: var(--font-button-sm-weight, 600);
        line-height: var(--font-button-sm-line-height, 1.4);
        letter-spacing: var(--font-button-sm-letter-spacing, 0);
        text-align: center;
        white-space: nowrap;
        cursor: pointer;
        appearance: none;
        transform: none !important;
        translate: none !important;
        transition:
          background-color 0.2s ease,
          color 0.2s ease,
          opacity 0.2s ease;
      }

      [data-testid="form"] [data-testid="btn-form-submit"]:hover,
      [data-testid="form"] [data-testid="btn-form-submit"]:active {
        background-color: var(--surface-brand-dark, #4d9d34);
        color: var(--text-invert, #fff);
        transform: none !important;
        translate: none !important;
      }

      [data-testid="form"] [data-testid="btn-form-submit"]:focus-visible {
        background-color: var(--surface-brand-dark, #4d9d34);
        color: var(--text-invert, #fff);
        outline: 2px solid var(--border-brand-dark, #4d9d34);
        outline-offset: 2px;
        transform: none !important;
        translate: none !important;
      }

      [data-testid="form"] [data-testid="btn-form-submit"][aria-disabled='true'] {
        opacity: 0.3;
        cursor: not-allowed;
      }

    `;

    const ensureStyles = (shadowRoot) => {
      let style = shadowRoot.querySelector(`[${STYLE_ATTR}]`);

      if (!style) {
        style = document.createElement('style');
        style.setAttribute(STYLE_ATTR, '');
        shadowRoot.appendChild(style);
      }

      if (style.textContent !== FORM_CSS) {
        style.textContent = FORM_CSS;
      }
    };

    // Class names are hashed per release, so match the title Forms renders by its text
    const hideDuplicateTitle = (shadowRoot, host) => {
      if (host.getAttribute('data-renders-title') !== 'true') return;

      const pageTitle = host.getAttribute('data-page-title')?.trim();
      if (!pageTitle) return;

      for (const node of shadowRoot.querySelectorAll('[data-testid="form-title"], h1, h2, h3')) {
        if (node.textContent.trim() !== pageTitle) continue;

        node.setAttribute(HIDDEN_TITLE_ATTR, '');
      }
    };

    /*
     * Forms absolutely positions the option list against the field wrapper, which holds the
     * label as well as the control. Opening downwards uses `top: 100%`, so the list lands flush
     * under the control. Opening upwards uses `bottom: 100%`, which is the top of the label, so
     * the list floats clear of the control and strands the label in the gap. Re-anchor the list
     * to the control; the offset is measured rather than assumed so a wrapped label still works.
     */
    const reanchorUpwardDropdowns = (shadowRoot) => {
      for (const dropdown of shadowRoot.querySelectorAll('[class*="dropdownContainer"]')) {
        const wrapper = dropdown.closest('[class*="selectContainer"]');
        const control = wrapper?.querySelector('[class*="selectToggle"]');

        if (!control || !dropdown.className.includes('showUpwards')) {
          dropdown.style.bottom = '';
          continue;
        }

        const offset = wrapper.getBoundingClientRect().bottom - control.getBoundingClientRect().top;
        const bottom = `${Math.round(offset)}px`;

        if (dropdown.style.bottom !== bottom) {
          dropdown.style.bottom = bottom;
        }
      }
    };

    const enhanceShadowRoot = (shadowRoot, host) => {
      if (shadowRoot.__returnsFormEnhancing) return;

      shadowRoot.__returnsFormEnhancing = true;

      try {
        ensureStyles(shadowRoot);
        hideDuplicateTitle(shadowRoot, host);
        reanchorUpwardDropdowns(shadowRoot);
      } finally {
        shadowRoot.__returnsFormEnhancing = false;
      }
    };

    // Forms rebuilds its shadow tree between steps, so the styling has to be re-applied
    const observeShadowRoot = (embed, shadowRoot, host) => {
      if (embed.dataset.returnsFormObserved === 'true') return;

      embed.dataset.returnsFormObserved = 'true';

      const observer = new MutationObserver(() => {
        enhanceShadowRoot(shadowRoot, host);
      });

      observer.observe(shadowRoot, { childList: true, subtree: true });
    };

    const attachWhenReady = (embed, host) => {
      const shadowRoot = embed.shadowRoot;
      if (!shadowRoot) return false;

      enhanceShadowRoot(shadowRoot, host);
      observeShadowRoot(embed, shadowRoot, host);
      return true;
    };

    // Shadow attach does not mutate light DOM, so poll until the upgrade completes
    const waitForShadowRoot = (embed, host) => {
      if (embed.dataset.returnsFormWaiting === 'true') return;

      embed.dataset.returnsFormWaiting = 'true';

      const maxAttempts = 80;
      let attempts = 0;

      const poll = () => {
        if (attachWhenReady(embed, host)) {
          delete embed.dataset.returnsFormWaiting;
          return;
        }

        attempts += 1;

        if (attempts >= maxAttempts) {
          delete embed.dataset.returnsFormWaiting;
          return;
        }

        window.setTimeout(poll, 50);
      };

      poll();
    };

    const collectEmbeds = (host) => {
      const embeds = [...host.querySelectorAll('shopify-forms-embed')];
      const seen = new Set(embeds);

      for (const root of host.querySelectorAll('[data-form-root], [data-forms-id]')) {
        if (root.shadowRoot && !seen.has(root)) {
          embeds.push(root);
          seen.add(root);
        }

        for (const child of root.children) {
          if (child.shadowRoot && !seen.has(child)) {
            embeds.push(child);
            seen.add(child);
          }
        }
      }

      return embeds;
    };

    // Containment is the scope: the inline app block renders inside this section
    const scan = () => {
      for (const host of document.querySelectorAll(HOST_SELECTOR)) {
        for (const embed of collectEmbeds(host)) {
          if (attachWhenReady(embed, host)) continue;

          waitForShadowRoot(embed, host);
        }
      }
    };

    const whenFormsDefined = () => {
      if (!window.customElements?.whenDefined) return Promise.resolve();
      if (window.customElements.get('shopify-forms-embed')) return Promise.resolve();

      return window.customElements.whenDefined('shopify-forms-embed');
    };

    const start = () => {
      scan();

      if (window.__meacoReturnsFormHelpersBound) return;
      window.__meacoReturnsFormHelpersBound = true;

      const documentObserver = new MutationObserver(() => {
        scan();
      });

      documentObserver.observe(document.documentElement, {
        childList: true,
        subtree: true,
      });

      whenFormsDefined().then(scan);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["warranty-form-helpers"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const HOST_SELECTOR = '[data-warranty-form-helpers]';
    const HELPER_ATTR = 'data-warranty-form-helper';
    const STYLE_ATTR = 'data-warranty-form-helper-style';
    const COLUMNS_ATTR = 'data-warranty-form-columns';
    const LEAD_HOST_ATTR = 'data-warranty-form-lead-host';
    const DEFAULT_FORM_ID = '1112266';
    const SERIAL_HELPER_ID = 'warranty-serial-number-helper';
    const PROOF_HELPER_ID = 'warranty-proof-of-purchase-helper';
    const SUBMIT_SELECTOR = '[data-testid="btn-form-submit"]';

    // Rebuilding a field in the Forms editor suffixes its key (serial_number -> serial_number_1)
    // and the Models label has been both singular and plural, so anchor on prefixes not exact ids
    const SERIAL_TEST_SELECTOR = '[data-testid^="field-custom#serial_number"]';
    const SERIAL_FIELD_SELECTOR = '[id^="custom#serial_number"]';
    const MODELS_LABEL_SELECTOR = '[id^="custom#model"][id$="-selector-label"]';

    const HELPER_CSS = `
      :host {
        --inline-container-max-width: 920px;
        --container-max-w: 920px;
        --warranty-form-columns-gap: 30px;
      }

      [data-sizing="form-wrapper"] [class*="formContainer"] {
        max-width: var(--inline-container-max-width, 920px);
        width: 100%;
        overflow: visible;
      }

      [data-testid="form"] {
        display: flex;
        box-sizing: border-box;
        flex-direction: column;
        width: 100%;
        max-width: 100%;
      }

      .warranty-form-columns {
        display: grid;
        grid-template-columns: 1fr;
        gap: var(--warranty-form-columns-gap);
        box-sizing: border-box;
        width: 100%;
        max-width: 100%;
        padding-inline: 2px;
      }

      .warranty-form-column {
        display: flex;
        flex-direction: column;
        gap: var(--spacing-2xs, 12px);
        min-width: 0;
        overflow: visible;
      }

      /* Lead-capture hosts measure zero but still take a column gap, dropping every field below */
      .warranty-form-column [data-warranty-form-lead-host] {
        display: none;
      }

      .warranty-form-column [class*="formInputField"],
      .warranty-form-column [class*="formPhoneInputField"],
      .warranty-form-column [class*="formFieldContainer"],
      .warranty-form-column [class*="formFileInput"],
      .warranty-form-column [class*="radioFieldSet"],
      .warranty-form-column [class*="selectContainer"] {
        min-width: 0;
        max-width: 100%;
        overflow: visible;
      }

      /* Keep long model names inside the closed select; menu panel stays overflow:visible above */
      .warranty-form-column [class*="selectToggle"] {
        box-sizing: border-box;
        display: flex;
        align-items: center;
        gap: var(--spacing-3xs, 8px);
        min-width: 0;
        max-width: 100%;
        overflow: hidden;
      }

      /* :where() keeps the :not() exclusions under the 0 4 0 specificity cap */
      .warranty-form-column [class*="selectToggle"] > :where(
        *:not(svg):not([class*="icon"]):not([class*="chevron"]):not([class*="Caret"]):not([class*="caret"])
      ) {
        flex: 1 1 auto;
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .warranty-form-column [class*="selectToggle"] :where(
        svg,
        [class*="icon"],
        [class*="chevron"],
        [class*="Caret"],
        [class*="caret"]
      ) {
        flex: 0 0 auto;
      }

      .warranty-form-heading {
        margin: 0 0 0.15em;
        font: var(--forms-heading-font, inherit);
        font-size: 18px;
        font-weight: 600;
        line-height: 1.3;
        color: var(--heading-text-color, var(--form-text-color, inherit));
        text-align: left;
      }

      .warranty-form-helper {
        margin: 0.5em 0 1em;
        font: var(--forms-body-font, inherit);
        color: var(--form-text-color, inherit);
        line-height: 1.45;
        text-align: left;
      }

      .warranty-form-helper strong {
        font-weight: 600;
      }

      /* Mirrors .button--primary from snippets/button.liquid. The class cannot reach into the
         Forms shadow root, but the design tokens it reads inherit through the boundary */
      [data-testid="form"] [data-testid="btn-form-submit"] {
        display: inline-flex;
        box-sizing: border-box;
        align-items: center;
        align-self: start;
        justify-content: center;
        width: fit-content;
        min-width: 0;
        max-width: 100%;
        min-height: var(--size-8, 32px);
        margin: 0;
        /* The theme button's 1px transparent border is folded into the padding instead.
           Forms zeroes border-width on hover with a rule we can't outrank, which shrank
           the button by 2px the moment the pointer landed on it */
        padding: calc(var(--spacing-3xs, 8px) + 1px) calc(var(--spacing-xs, 16px) + 1px);
        border: 0;
        border-radius: var(--radius-full, 360px);
        background-color: var(--surface-brand-dark, #4d9d34);
        color: var(--text-invert, #fff);
        box-shadow: none;
        font-family: var(--font-subheading--family, inherit);
        font-size: var(--font-button-sm-size, 12px);
        font-weight: var(--font-button-sm-weight, 600);
        line-height: var(--font-button-sm-line-height, 1.4);
        letter-spacing: var(--font-button-sm-letter-spacing, 0);
        text-align: center;
        white-space: nowrap;
        cursor: pointer;
        appearance: none;
        transform: none !important;
        translate: none !important;
        transition:
          background-color 0.2s ease,
          color 0.2s ease,
          opacity 0.2s ease;
      }

      [data-testid="form"] [data-testid="btn-form-submit"]:hover,
      [data-testid="form"] [data-testid="btn-form-submit"]:active {
        background-color: var(--surface-brand-dark, #4d9d34);
        color: var(--text-invert, #fff);
        transform: none !important;
        translate: none !important;
      }

      [data-testid="form"] [data-testid="btn-form-submit"]:focus-visible {
        background-color: var(--surface-brand-dark, #4d9d34);
        color: var(--text-invert, #fff);
        outline: 2px solid var(--border-brand-dark, #4d9d34);
        outline-offset: 2px;
        transform: none !important;
        translate: none !important;
      }

      /* No pointer-events: none, unlike the theme button — the app still needs the
         click to surface its own validation messages */
      [data-testid="form"] [data-testid="btn-form-submit"][aria-disabled='true'] {
        opacity: 0.3;
        cursor: not-allowed;
      }

      @media screen and (min-width: 750px) {
        .warranty-form-columns {
          grid-template-columns: 1fr 1fr;
          align-items: start;
        }
      }
    `;

    const getHost = () => document.querySelector(HOST_SELECTOR);

    const getTargetFormId = () =>
      getHost()?.getAttribute('data-form-id')?.trim() || DEFAULT_FORM_ID;

    const readCopy = () => {
      const host = getHost();
      if (!host) return null;

      const serialHelper = host.getAttribute('data-serial-helper')?.trim();
      const proofIntro = host.getAttribute('data-proof-intro')?.trim();
      const proofBody = host.getAttribute('data-proof-body')?.trim();
      const customerDetails = host.getAttribute('data-customer-details')?.trim();
      const productDetails = host.getAttribute('data-product-details')?.trim();

      if (
        !serialHelper ||
        !proofIntro ||
        !proofBody ||
        !customerDetails ||
        !productDetails
      ) {
        return null;
      }

      return { serialHelper, proofIntro, proofBody, customerDetails, productDetails };
    };

    const matchesFormId = (embed, formId) => {
      const expected = `forms-root-${formId}`;
      const formsRoot = embed.closest('[data-forms-id]');
      const formsId = formsRoot?.getAttribute('data-forms-id') || '';

      return formsId === expected || formsId === formId || formsId.endsWith(`-${formId}`);
    };

    const ensureStyles = (shadowRoot) => {
      if (shadowRoot.querySelector(`[${STYLE_ATTR}]`)) return;

      const style = document.createElement('style');
      style.setAttribute(STYLE_ATTR, '');
      style.textContent = HELPER_CSS;
      shadowRoot.appendChild(style);
    };

    const findSerialInput = (root) =>
      root.querySelector(SERIAL_TEST_SELECTOR) || root.querySelector(SERIAL_FIELD_SELECTOR);

    const findFileInput = (root) => root.querySelector('input[type="file"]');

    const findForm = (root) =>
      root.querySelector('[data-testid="form"]') || root.querySelector('form');

    const findChildContaining = (parent, selector) =>
      [...parent.children].find(
        (child) => child.matches?.(selector) || child.querySelector?.(selector)
      );

    const isLeadCapture = (node) =>
      node.tagName === 'SHOP-LEAD-CAPTURE' || Boolean(node.querySelector?.('shop-lead-capture'));

    // The lead-capture wrapper is an empty div until Shopify upgrades it, so it reads as
    // an ordinary child while fields are being packed and would occupy a column gap
    const isLayoutOnly = (node) =>
      isLeadCapture(node) ||
      (!node.querySelector?.('input, select, textarea, button') &&
        !(node.textContent || '').trim());

    // Hosts that upgrade after packing stay put; CSS collapses them once flagged
    const flagLeadHosts = (form) => {
      for (const column of form.querySelectorAll('[data-warranty-form-column]')) {
        for (const child of column.children) {
          if (isLeadCapture(child)) {
            child.setAttribute(LEAD_HOST_ATTR, '');
          }
        }
      }
    };

    const isSubmitControl = (node) =>
      node.matches?.(SUBMIT_SELECTOR) || Boolean(node.querySelector?.(SUBMIT_SELECTOR));

    const findProductStart = (form) =>
      findChildContaining(form, MODELS_LABEL_SELECTOR) ||
      findChildContaining(form, SERIAL_TEST_SELECTOR) ||
      findChildContaining(form, SERIAL_FIELD_SELECTOR);

    const adoptStrayProductFields = (form) => {
      const productCol = form.querySelector('[data-warranty-form-column="product"]');
      if (!productCol) return;

      const columns = form.querySelector(`[${COLUMNS_ATTR}]`);
      const strays = [...form.children].filter((child) => {
        if (child === columns) return false;
        if (isSubmitControl(child) || isLayoutOnly(child)) return false;
        return true;
      });

      for (const stray of strays) {
        productCol.appendChild(stray);
      }
    };

    const setDescribedBy = (control, helperId) => {
      if (!control) return;

      const existing = (control.getAttribute('aria-describedby') || '')
        .split(/\s+/)
        .filter(Boolean);

      if (!existing.includes(helperId)) {
        existing.push(helperId);
        control.setAttribute('aria-describedby', existing.join(' '));
      }
    };

    const buildSerialHelper = (text) => {
      const helper = document.createElement('p');
      helper.id = SERIAL_HELPER_ID;
      helper.className = 'warranty-form-helper';
      helper.setAttribute(HELPER_ATTR, 'serial');
      helper.textContent = text;
      return helper;
    };

    const buildProofHelper = (intro, body) => {
      const helper = document.createElement('p');
      helper.id = PROOF_HELPER_ID;
      helper.className = 'warranty-form-helper';
      helper.setAttribute(HELPER_ATTR, 'proof');

      const strong = document.createElement('strong');
      strong.textContent = intro;
      helper.appendChild(strong);
      helper.appendChild(document.createTextNode(` - ${body}`));

      return helper;
    };

    const buildHeading = (text, id) => {
      const heading = document.createElement('h3');
      heading.id = id;
      heading.className = 'warranty-form-heading';
      heading.textContent = text;
      return heading;
    };

    const buildColumn = (name, headingText, headingId, fields) => {
      const column = document.createElement('div');
      column.className = 'warranty-form-column';
      column.setAttribute('data-warranty-form-column', name);
      column.setAttribute('role', 'group');
      column.setAttribute('aria-labelledby', headingId);
      column.appendChild(buildHeading(headingText, headingId));

      for (const field of fields) {
        column.appendChild(field);
      }

      return column;
    };

    const applyColumnLayout = (root, copy, formId) => {
      const form = findForm(root);
      if (!form) return;

      if (form.querySelector(`[${COLUMNS_ATTR}]`)) {
        adoptStrayProductFields(form);
        flagLeadHosts(form);
        return;
      }

      const productStart = findProductStart(form);
      const submit = findChildContaining(form, SUBMIT_SELECTOR);

      // Serial renders before proof-of-purchase and submit; wait so Product Details is complete
      if (!productStart || !submit || !findFileInput(form)) return;

      const children = [...form.children];
      const productIndex = children.indexOf(productStart);
      const submitIndex = children.indexOf(submit);

      const customerStart = children.find((child, index) => {
        if (index >= productIndex) return false;
        return !isLayoutOnly(child);
      });

      if (!customerStart) return;

      const layoutFields = (nodes) =>
        nodes.filter((node) => !isLayoutOnly(node) && !isSubmitControl(node));

      const customerFields = layoutFields(
        children.slice(children.indexOf(customerStart), productIndex)
      );
      const productFields = layoutFields(children.slice(productIndex, submitIndex));
      const trailingLeads = children.slice(productIndex, submitIndex).filter(isLeadCapture);

      if (!customerFields.length || !productFields.length) return;

      const columns = document.createElement('div');
      columns.className = 'warranty-form-columns';
      columns.setAttribute(COLUMNS_ATTR, '');

      columns.append(
        buildColumn(
          'customer',
          copy.customerDetails,
          `WarrantyCustomerDetails-${formId}`,
          customerFields
        ),
        buildColumn(
          'product',
          copy.productDetails,
          `WarrantyProductDetails-${formId}`,
          productFields
        )
      );

      form.insertBefore(columns, submit);

      // Lead-capture skipped by the slices would otherwise sit above the grid
      for (const lead of trailingLeads) {
        form.insertBefore(lead, submit);
      }

      flagLeadHosts(form);
    };

    const injectSerialHelper = (root, copy) => {
      if (root.querySelector(`[${HELPER_ATTR}="serial"]`)) return;

      const serialInput = findSerialInput(root);
      if (!serialInput) return;

      const fieldContainer =
        serialInput.closest('[class*="formFieldContainer"]') || serialInput.parentElement;
      if (!fieldContainer?.parentElement) return;

      const helper = buildSerialHelper(copy.serialHelper);
      fieldContainer.insertAdjacentElement('afterend', helper);
      setDescribedBy(serialInput, SERIAL_HELPER_ID);
    };

    const injectProofHelper = (root, copy) => {
      if (root.querySelector(`[${HELPER_ATTR}="proof"]`)) return;

      const fileInput = findFileInput(root);
      if (!fileInput) return;

      const fileField =
        fileInput.closest('[class*="formFileInputField"]') ||
        fileInput.closest('[class*="formFileInput"]') ||
        fileInput.parentElement;
      if (!fileField) return;

      const fileGroup = fileField.parentElement;
      const existingLead =
        fileGroup?.querySelector(':scope > p') || fileField.previousElementSibling;

      const helper = buildProofHelper(copy.proofIntro, copy.proofBody);

      if (
        existingLead &&
        existingLead.tagName === 'P' &&
        !existingLead.hasAttribute(HELPER_ATTR)
      ) {
        existingLead.replaceWith(helper);
      } else {
        fileField.insertAdjacentElement('beforebegin', helper);
      }

      setDescribedBy(fileInput, PROOF_HELPER_ID);
    };

    // The button label is owned by the Forms app, so it can only be swapped once it has rendered
    const applySubmitLabel = (root) => {
      const label = getHost()?.getAttribute('data-submit-label')?.trim();
      if (!label) return;

      const submit = root.querySelector(SUBMIT_SELECTOR);
      if (!submit) return;

      // While submitting, the app replaces the label with a spinner element
      if (submit.firstElementChild) return;
      if (submit.textContent.trim() === label) return;

      submit.textContent = label;
    };

    const enhanceShadowRoot = (embed, shadowRoot) => {
      const copy = readCopy();
      if (!copy) return;

      // Overlay-group is global; only enhance the configured Forms embed. The form id is the
      // only gate, so a renamed field costs one helper rather than the whole layout
      if (!matchesFormId(embed, getTargetFormId())) return;

      ensureStyles(shadowRoot);
      applyColumnLayout(shadowRoot, copy, getTargetFormId());
      injectSerialHelper(shadowRoot, copy);
      injectProofHelper(shadowRoot, copy);
      applySubmitLabel(shadowRoot);
    };

    const observeShadowRoot = (embed, shadowRoot) => {
      if (embed.dataset.warrantyHelpersObserved === 'true') return;

      embed.dataset.warrantyHelpersObserved = 'true';

      const observer = new MutationObserver(() => {
        enhanceShadowRoot(embed, shadowRoot);
      });

      observer.observe(shadowRoot, { childList: true, subtree: true });
    };

    const attachWhenReady = (embed) => {
      const shadowRoot = embed.shadowRoot;
      if (!shadowRoot) return false;

      enhanceShadowRoot(embed, shadowRoot);
      observeShadowRoot(embed, shadowRoot);
      return true;
    };

    // Shadow attach does not mutate light DOM, so poll until upgrade completes
    const waitForShadowRoot = (embed) => {
      if (embed.dataset.warrantyHelpersWaiting === 'true') return;

      embed.dataset.warrantyHelpersWaiting = 'true';

      const maxAttempts = 80;
      let attempts = 0;

      const poll = () => {
        if (attachWhenReady(embed)) {
          delete embed.dataset.warrantyHelpersWaiting;
          return;
        }

        attempts += 1;

        if (attempts >= maxAttempts) {
          delete embed.dataset.warrantyHelpersWaiting;
          return;
        }

        window.setTimeout(poll, 50);
      };

      poll();
    };

    const enhanceEmbed = (embed) => {
      if (!(embed instanceof HTMLElement)) return;
      if (!matchesFormId(embed, getTargetFormId())) return;

      if (attachWhenReady(embed)) return;

      waitForShadowRoot(embed);
    };

    const scan = () => {
      if (!readCopy()) return;

      for (const embed of document.querySelectorAll('shopify-forms-embed')) {
        enhanceEmbed(embed);
      }
    };

    const whenFormsDefined = () => {
      if (!window.customElements?.whenDefined) return Promise.resolve();
      if (window.customElements.get('shopify-forms-embed')) return Promise.resolve();

      return window.customElements.whenDefined('shopify-forms-embed');
    };

    const start = () => {
      scan();

      if (window.__meacoWarrantyFormHelpersBound) return;
      window.__meacoWarrantyFormHelpersBound = true;

      const documentObserver = new MutationObserver(() => {
        scan();
      });

      documentObserver.observe(document.documentElement, {
        childList: true,
        subtree: true,
      });

      whenFormsDefined().then(scan);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
